import { useContext } from 'react'
import { RouteIdContext } from '../contexts'

export const useRouteId = () => {
  const { routeId } = useContext(RouteIdContext)
  return routeId
}
